// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.documents-table-container {
  margin: 2rem 0;
  overflow-x: auto;
}

.documents-table {
  border-collapse: collapse;
  width: 100%;
  background: #fff;
}

.documents-table th,
.documents-table td {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #e0e0e0;
  vertical-align: top;
  min-width: 120px;
}

.documents-table th {
  background: #f5f5f5;
  font-weight: 600;
}

.documents-table td {
  font-size: 1rem;
}

.text-center {
  text-align: center;
}

.text-muted {
  color: #888;
}

.v-align-middle {
  vertical-align: middle !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/dispute-resolution/public-view-documents-list/public-view-documents-list.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,yBAAA;EACA,WAAA;EACA,gBAAA;AACF;;AAEA;;EAEE,qBAAA;EACA,gCAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,iCAAA;AACF","sourcesContent":[".documents-table-container {\r\n  margin: 2rem 0;\r\n  overflow-x: auto;\r\n}\r\n\r\n.documents-table {\r\n  border-collapse: collapse;\r\n  width: 100%;\r\n  background: #fff;\r\n}\r\n\r\n.documents-table th,\r\n.documents-table td {\r\n  padding: 0.75rem 1rem;\r\n  border-bottom: 1px solid #e0e0e0;\r\n  vertical-align: top;\r\n  min-width: 120px;\r\n}\r\n\r\n.documents-table th {\r\n  background: #f5f5f5;\r\n  font-weight: 600;\r\n}\r\n\r\n.documents-table td {\r\n  font-size: 1rem;\r\n}\r\n\r\n.text-center {\r\n  text-align: center;\r\n}\r\n\r\n.text-muted {\r\n  color: #888;\r\n}\r\n\r\n.v-align-middle {\r\n  vertical-align: middle !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
